<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="!hasList('puff-collection-no-image'); else noImageList">
    <ng-container
      *ngIf="
        data?.linkLoc &&
          !hasList('puff-collection-content-right-2') &&
          !hasList('puff-collection-banners-2') &&
          !hasList('puff-collection-content-bottom-2') &&
          !hasList('puff-collection-banners-3') &&
          !hasList('puff-collection-with-links') &&
          !hasList('puff-collection-banners-with-button');
        else noLink
      "
    >
      <ng-container *ngIf="getReadMoreExpanded(); else templateReadMoreNotExpanded">
        <cx-generic-link class="puff-holder has-link" [url]="data.linkLoc" [target]="getTarget(data)">
          <ng-container *ngTemplateOutlet="puff; context: { allowLinks: false }"></ng-container>
        </cx-generic-link>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #templateReadMoreNotExpanded>
    <div class="puff-holder has-link" (click)="toggleReadMore()">
      <ng-container *ngTemplateOutlet="puff; context: { allowLinks: true }"></ng-container>
    </div>
  </ng-template>

  <ng-template #noLink>
    <div class="puff-holder">
      <ng-container *ngTemplateOutlet="puff; context: { allowLinks: true }"></ng-container>
    </div>
  </ng-template>

  <ng-template #noImageList>
    <div>{{ data?.titleLoc }}</div>
    <div>{{ data?.bodyLoc }}</div>
  </ng-template>

  <ng-template #puff let-allowLinks="allowLinks">
    <div class="puff">
      <div class="puff-image">
        <py-puff-collection-content-tags
          *ngIf="data?.contentTags?.split"
          [contentTagUids]="data?.contentTags.split(' ')"
        ></py-puff-collection-content-tags>
        <div class="image-wrapper">
          <img
            [pyMedia]="data?.mediaLoc"
            [alt]="
              data?.titleLoc
                ? data.titleLoc === data?.mediaLoc?.altText
                  ? ''
                  : data?.mediaLoc?.altText
                : (data?.mediaLoc?.altText ?? data?.name ?? '')
            "
          />
        </div>
        <div class="hover-overlay"></div>
      </div>

      <py-published-date *ngIf="hasList('puff-collection-content-bottom')" [label]="data?.linkLoc"></py-published-date>

      <div class="puff-text">
        <ng-content
          *ngIf="
            !hasList('puff-collection-content-bottom-4') && !hasList('puff-collection-content-bottom-7');
            else plainTitleTemplate
          "
        >
          <h2 class="h5 puff-title" *ngIf="data.titleLoc">
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          </h2>
        </ng-content>
        <ng-template #plainTitleTemplate>
          <div class="h5 puff-title">
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          </div>
        </ng-template>
        <ng-template #titleTemplate>
          <ng-container *ngIf="allowLinks && hasList('puff-collection-content-right-2') && data.linkLoc; else noPermalinkTitle">
            <cx-generic-link [url]="data.linkLoc" [target]="getTarget(data)">
              {{ data?.titleLoc }} <i nz-icon nzType="arrow-right" nzTheme="outline" class="ml-3"></i
            ></cx-generic-link>
          </ng-container>

          <i class="ml-3 title-arrow" nz-icon nzType="arrow-right" nzTheme="outline"></i>
        </ng-template>
        <ng-template #noPermalinkTitle>
          {{ data?.titleLoc }}
        </ng-template>

        <py-read-more
          class="puff-description"
          [content]="data.bodyLoc"
          *ngIf="showReadMore(); else defaultBodyLocTemplate"
          [(isReadMoreExpanded)]="isReadMoreExpanded"
        ></py-read-more>

        <ng-template #defaultBodyLocTemplate>
          <div
            class="puff-description"
            *ngIf="data.bodyLoc && !hasList('puff-collection-content-bottom-4')"
            [innerHTML]="data.bodyLoc"
          ></div>
        </ng-template>

        <div
          class="read-more-link"
          *ngIf="
            (hasList('puff-collection-banners') ||
              hasList('puff-collection-banners-2') ||
              hasList('puff-collection-banners-3') ||
              hasList('puff-collection-content-3') ||
              hasList('puff-collection-with-links')) &&
            data?.linkLoc &&
            data?.linkLoc !== '#'
          "
        >
          <cx-generic-link *ngIf="allowLinks; else noPermalinkReadMoreLink" [url]="data.linkLoc" [target]="getTarget(data)">
            <ng-container *ngTemplateOutlet="noPermalinkReadMoreLink"></ng-container>
          </cx-generic-link>
          <ng-template #noPermalinkReadMoreLink>
            <span class="read-more-link-text">
              <ng-container *ngIf="data.leadTextLoc">{{ data.leadTextLoc }} </ng-container>
              <ng-container *ngIf="!data.leadTextLoc">{{ 'common.readMore_action' | cxTranslate }}</ng-container>
            </span>
          </ng-template>
          <i nz-icon nzType="arrow-right" nzTheme="outline" class="ml-3"></i>
        </div>
        <div
          class="read-more-button mt-2"
          *ngIf="
            (hasList('puff-collection-banners-with-button') ||
              hasList('puff-collection-content-bottom-2') ||
              hasList('puff-collection-content-bottom-6')) &&
            data.linkLoc &&
            data?.linkLoc !== '#'
          "
        >
          <cx-generic-link *ngIf="allowLinks; else noPermalinkReadMoreButton" [url]="data.linkLoc" [target]="getTarget(data)">
            <ng-container *ngTemplateOutlet="noPermalinkReadMoreButton"></ng-container>
          </cx-generic-link>
          <ng-template #noPermalinkReadMoreButton>
            <div class="btn btn-secondary">
              <ng-container *ngIf="data.leadTextLoc">{{ data.leadTextLoc }} </ng-container>
              <ng-container *ngIf="!data.leadTextLoc">{{ 'common.readMore_action' | cxTranslate }}</ng-container>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
